<template>
  <div class="f-ast f-v">
    <div class="t t-xl ta-c m-tx3 m-bx3">
      Open <span class="bold">app.donut.ai</span> in another window.
      Now press these keys in order:
      <br>
      <br>
      <span class="bold">{{ konamiSequence }}</span>
      <br>
      <br>
      <span class="t-sm">(case doesn't matter)</span>
      <br>
      <br>
      🤫 Don't tell.
    </div>
    <donut-modal-sections-actions
      cancel-text="Close"
      button-text="Download"
      save-mutation="updateExistingModal"
      :save-args="{}"
      :save-function="downloadCopy"
    >
      <template #saveButton="{ buttonText }">
        <span>{{ buttonText }}</span>
        <i class="mi m-lx1">file_download</i>
      </template>
    </donut-modal-sections-actions>
  </div>
</template>

<script setup>
  const konamiSequence = '⬆️ ⬆️ ⬇️ ⬇️ ⬅️ ➡️ ⬅️ ➡️ 🅱️ 🅰️';
  const filename = 'donut-lore.txt';
  const textContent = [
    'Open app.donut.ai in another window.',
    'Now press these keys in order:',
    '',
    konamiSequence,
    "(case doesn't matter)",
    '',
    "🤫 Don't tell.",
  ].join('\n');

  const downloadCopy = () => {
    const blob = new Blob([textContent], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };
</script>
